import { render } from "./ResourcesFilterTag.vue?vue&type=template&id=7552dc40&scoped=true"
import script from "./ResourcesFilterTag.vue?vue&type=script&lang=js"
export * from "./ResourcesFilterTag.vue?vue&type=script&lang=js"

import "./ResourcesFilterTag.vue?vue&type=style&index=0&id=7552dc40&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7552dc40"

export default script